export default __webpack_public_path__ + "static/major-expenses-remote-workers-dont-talk-about-hero-image-e20fb0a2b74d3b1d88fcd72f2a842aaa.jpg";